import React from 'react';
import styled from 'styled-components';

import { RetinaPicture } from 'client/components/RetinaPicture';
import { PODCAST_COLORS } from 'client/utils';
import { useT } from 'client/i18n/hooks/useT';

// TODO https://anchorfm.atlassian.net/browse/CAST-2756: Update to final assets
const HeroSection = styled.section`
  position: relative;
  overflow: hidden;
  height: calc(100vw * 0.5625);
  width: 100%;
  display: flex;
  align-items: center;
`;

const BackgroundRetinaPicture = styled(RetinaPicture)`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const HeroContent = styled.div`
  max-width: 34%;
  margin-left: 4%;
  position: relative;
`;

const HeroTitle = styled.h1`
  font-size: 6.25rem;
  line-height: 90px;
  letter-spacing: -0.02em;
  color: ${PODCAST_COLORS.WHITE.color};
  margin-bottom: 25px;

  span {
    margin-top: 14px;
    display: block;
    font-size: 3.125rem;
    line-height: 50px;
    letter-spacing: -0.01em;
  }
`;

const HeroBody = styled.p`
  margin: 0;
  font-size: 1.563rem;
  line-height: 28px;
  letter-spacing: -0.01em;
  color: ${PODCAST_COLORS.WHITE.color};
`;

export function Hero() {
  const t = useT();

  return (
    <HeroSection>
      <BackgroundRetinaPicture
        fallbackExtension="jpg"
        imagePath="/videopartner/videopartner-hero-video-podcast"
        alt={t(
          'IntegrationConnectionScreen.Hero.ImageAltText',
          'Woman recording a video podcast with a ring light',
          'Alt text for the background image on the Integration Connection Screen'
        )}
      />
      <HeroContent>
        <HeroTitle
          dangerouslySetInnerHTML={{
            __html: t(
              'IntegrationConnectionScreen.Hero.Title',
              'Video Podcasts <span>by Spotify</span>',
              'The title for the Integration Connection Screen for Video Podcasts'
            ),
          }}
        />
        <HeroBody>
          {t(
            'IntegrationConnectionScreen.Hero.Body',
            'Create a podcast that fans can watch (or listen to) on Spotify.',
            'The body for the Integration Connection Screen for Video Podcasts'
          )}
        </HeroBody>
      </HeroContent>
    </HeroSection>
  );
}
